<template>
  <div class="col-12">
    <Search
      :title="$lang.myPayments"
      :allowFields="$lang.myReportPaymentsFields"
      :allowCollapse="false"
      :url="url"
      addModalSize="xl"
      removeModalSize="xl"
      :visibleSearch="true"
      :visibleSettings="true"
      :visibleExport="true"
      :visibleFilters="true"
      :visibleViewCount="true"
      :visibleAdd="false"
      :allowEdit="false"
      :allowOperate="false"
      ref="reportPaymentSearch"
      :filterCatch="true"
    />
  </div>
</template>

<script>
import Search from "@/components/base/search";

export default {
  components: { Search },
  data() {
    return {
      url: this.$config.api_url + this.$config.report.myPayments,
    };
  },
};
</script>
